import Api from "./Api";
import ApiNode from "./ApiNode";

export default {
  getAllProfitLoss(payload) {
    console.log("payload AllProfitLoss=>", payload);
    let AllProfitLoss = Api().post(
      "Api_Dashboard/getAllProfitLoss.php",
      payload,
    );
    return AllProfitLoss;
  },

  getPendingApprovals(payload) {
    return ApiNode().post("profit-loss/approval/pending", payload);
  },

  approveProfitLoss(payload) {
    return ApiNode().post("profit-loss/approval/approve", payload);
  },

  rejectProfitLoss(payload) {
    return ApiNode().post("profit-loss/approval/reject", payload);
  },

  sendForApproval(payload) {
    return ApiNode().post("profit-loss/approval/send", payload);
  },

  getProfitLossList(payload) {
    return ApiNode().post("profit-loss/list", payload);
  },

  getLogRecords(payload) {
    return ApiNode().post("profit-loss/log", payload);
  },

  bulkUploadProfitLoss(payload) {
    return ApiNode().post("profit-loss/upload-excel", payload);
  },

  getProfitLossCountsByDate(payload) {
    return ApiNode().post("profit-loss/counts-by-date", payload);
  },

  getBranchWiseTeus(payload = {}) {
    return ApiNode().post("sales-person-client-map/branch-wise-teus", payload);
  },

  getClientWiseTues(payload = {}) {
    return ApiNode().post("sales-person-client-map/client-wise-tues", payload);
  },

  getShippingLineWiseTues(payload = {}) {
    return ApiNode().post(
      "sales-person-client-map/shipping-line-wise-tues",
      payload,
    );
  },

  getContainerTypeWiseTues(payload = {}) {
    return ApiNode().post(
      "sales-person-client-map/container-type-wise-tues",
      payload,
    );
  },
};



// WEBPACK FOOTER //
// ./src/services/ProfitLossService.js